import React from 'react';
import { connect } from 'react-redux';
import { error } from '../selectors';
import {ERROR_CODE_EXPIRED_ACTIVATION_LINK, ERROR_CODE_ALREADY_REGISTERED } from '../constants';

const actionsToProps = dispatch => ({});

const stateToProps = state => ({
  error: error(state),
});

const ErrorPage = props => {
    let message = 'Something went wrong during registration process.';
    let subMessage = 'Please, try again.';
    if (props.error.message) {
      if (props.error.code === ERROR_CODE_EXPIRED_ACTIVATION_LINK) {
        message = 'The activation link that was emailed to you has expired.';
        subMessage = 'Please repeat the email registration process. ';
      } else {
        message = props.error.message;
        subMessage = '';
      }
    }

    return (
      <form className="reg-form table-cell">
        <div className="registration-status error">
          <p className="head--txt">Registration failed!</p>
          {props.error.code === ERROR_CODE_ALREADY_REGISTERED ?
            <p
                className="intro--txt mt15 ml10"
                dangerouslySetInnerHTML={(() => ({
                  __html: `${message} `,
                }))()}
            />
            :
            <p className="intro--txt mt15 ml10">
              {message}
            </p>
          }
          <p className="intro--txt ml10">
            {subMessage}
          </p>
        </div>
      </form>
    );
}

export default connect(
    stateToProps,
    actionsToProps
)(ErrorPage);